import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 1,
  cursor: "pointer",
  userSelect: "none",
};

export const rootDisabled: SxProps<Theme> = {
  cursor: "not-allowed",
  opacity: 0.5,
};

export const label: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: "0.875rem",
  color: "text.primary",
};

export const iconWrap: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};
